import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Skeleton } from '@/components/ui/skeleton'

export const DisableSsoDialogFallback = () => (
  <>
    <AlertDialogHeader>
      <AlertDialogTitle>Disable SSO</AlertDialogTitle>
      <AlertDialogDescription>
        <Skeleton className="h-4 w-full" />
      </AlertDialogDescription>
    </AlertDialogHeader>
    <AlertDialogFooter>
      <AlertDialogCancel disabled>Cancel</AlertDialogCancel>
      <AlertDialogAction disabled>Continue</AlertDialogAction>
    </AlertDialogFooter>
  </>
)
